import axios from "axios";
const axiosApiInstance = axios.create();

// Request interceptor for API calls
axiosApiInstance.interceptors.request.use(
  async (config) => {
    try {
      const authUser = localStorage.getItem("authUser");
      if (authUser) {
        const { token } = JSON.parse(authUser);
        if (token) {
          config.headers = {
            ...config.headers,
            Authorization: `Bearer ${token}`,
          };
        }
      }
    } catch (e) {
      console.warn("Error parsing auth token", e);
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);
export const GetData = async (url) => {
  try {
    // SIEMPRE respetar REACT_APP_API si está definida
    // Si no está definida o apunta a localhost/127.0.0.1, usar desarrollo local
    const backendUrl = process.env.REACT_APP_API || 'http://127.0.0.1:5001';
    
    // Determinar si estamos en desarrollo local (solo si REACT_APP_API apunta a localhost o no está definida)
    const isLocal = !process.env.REACT_APP_API || 
                    process.env.REACT_APP_API.includes('localhost') || 
                    process.env.REACT_APP_API.includes('127.0.0.1');
    
    const isDevelopment = isLocal;
    
    // Asegurar que la URL empiece con /v1/
    let apiUrl = url.startsWith('/v1/') ? url : (url.startsWith('/') ? `/v1${url}` : `/v1/${url}`);
    
    // Si REACT_APP_API está definida, SIEMPRE usar URL completa
    if (process.env.REACT_APP_API) {
      apiUrl = apiUrl.replace(/^\/v1/, '');
      apiUrl = `${backendUrl}${apiUrl}`;
    } else if (isDevelopment) {
      apiUrl = apiUrl.replace(/^\/v1/, '');
      apiUrl = `${backendUrl}${apiUrl}`;
    } else {
      // Producción desplegada sin REACT_APP_API: usar rutas relativas /v1/...
    }
    
    const getData = await axiosApiInstance.get(apiUrl);
    return getData;
  } catch (err) {
    handledErrors(err);
  }
};

export const PostData = async (url, data, options) => {
  try {
    // SIEMPRE respetar REACT_APP_API si está definida
    const backendUrl = process.env.REACT_APP_API || 'http://127.0.0.1:5001';
    
    const isLocal = !process.env.REACT_APP_API || 
                    process.env.REACT_APP_API.includes('localhost') || 
                    process.env.REACT_APP_API.includes('127.0.0.1');
    
    const isDevelopment = isLocal;
    
    // Asegurar que la URL empiece con /v1/
    let apiUrl = url.startsWith('/v1/') ? url : (url.startsWith('/') ? `/v1${url}` : `/v1/${url}`);
    
    // Si REACT_APP_API está definida, SIEMPRE usar URL completa
    if (process.env.REACT_APP_API) {
      apiUrl = apiUrl.replace(/^\/v1/, '');
      apiUrl = `${backendUrl}${apiUrl}`;
    } else if (isDevelopment) {
      apiUrl = apiUrl.replace(/^\/v1/, '');
      apiUrl = `${backendUrl}${apiUrl}`;
    } else {
      // Producción desplegada sin REACT_APP_API: usar rutas relativas /v1/...
    }
    
    const defaultHeaders = {
      "Content-Type": "application/json",
    };
    const getData = await axiosApiInstance.post(
      apiUrl,
      data,
      options ? options : defaultHeaders
    );
    return getData;
  } catch (err) {
    handledErrors(err);
  }
};

export const PutData = async (url, data, options) => {
  try {
    // SIEMPRE respetar REACT_APP_API si está definida
    const backendUrl = process.env.REACT_APP_API || 'http://127.0.0.1:5001';
    
    const isLocal = !process.env.REACT_APP_API || 
                    process.env.REACT_APP_API.includes('localhost') || 
                    process.env.REACT_APP_API.includes('127.0.0.1');
    
    const isDevelopment = isLocal;
    
    // Asegurar que la URL empiece con /v1/
    let apiUrl = url.startsWith('/v1/') ? url : (url.startsWith('/') ? `/v1${url}` : `/v1/${url}`);
    
    // Si REACT_APP_API está definida, SIEMPRE usar URL completa
    if (process.env.REACT_APP_API) {
      apiUrl = apiUrl.replace(/^\/v1/, '');
      apiUrl = `${backendUrl}${apiUrl}`;
    } else if (isDevelopment) {
      apiUrl = apiUrl.replace(/^\/v1/, '');
      apiUrl = `${backendUrl}${apiUrl}`;
    } else {
      // Producción desplegada sin REACT_APP_API: usar rutas relativas /v1/...
    }
    
    const defaultHeaders = {
      "Content-Type": "application/json",
    };
    const getData = await axiosApiInstance.put(
      apiUrl,
      data,
      options ? options : defaultHeaders
    );
    return getData;
  } catch (err) {
    handledErrors(err);
  }
};

export const PatchData = async (url, data) => {
  try {
    const backendUrl = process.env.REACT_APP_API || 'http://127.0.0.1:5001';
    const isLocal = !process.env.REACT_APP_API ||
                    process.env.REACT_APP_API.includes('localhost') ||
                    process.env.REACT_APP_API.includes('127.0.0.1');
    let apiUrl = url.startsWith('/v1/') ? url : (url.startsWith('/') ? `/v1${url}` : `/v1/${url}`);
    if (process.env.REACT_APP_API) {
      apiUrl = apiUrl.replace(/^\/v1/, '');
      apiUrl = `${backendUrl}${apiUrl}`;
    } else if (isLocal) {
      apiUrl = apiUrl.replace(/^\/v1/, '');
      apiUrl = `${backendUrl}${apiUrl}`;
    }
    const result = await axiosApiInstance.patch(apiUrl, data);
    return result;
  } catch (err) {
    handledErrors(err);
  }
};

export const DeleteData = async (url) => {
  try {
    // SIEMPRE respetar REACT_APP_API si está definida
    const backendUrl = process.env.REACT_APP_API || 'http://127.0.0.1:5001';
    
    const isLocal = !process.env.REACT_APP_API || 
                    process.env.REACT_APP_API.includes('localhost') || 
                    process.env.REACT_APP_API.includes('127.0.0.1');
    
    const isDevelopment = isLocal;
    
    // Asegurar que la URL empiece con /v1/
    let apiUrl = url.startsWith('/v1/') ? url : (url.startsWith('/') ? `/v1${url}` : `/v1/${url}`);
    
    // Si REACT_APP_API está definida, SIEMPRE usar URL completa
    if (process.env.REACT_APP_API) {
      apiUrl = apiUrl.replace(/^\/v1/, '');
      apiUrl = `${backendUrl}${apiUrl}`;
    } else if (isDevelopment) {
      apiUrl = apiUrl.replace(/^\/v1/, '');
      apiUrl = `${backendUrl}${apiUrl}`;
    } else {
      // Producción desplegada sin REACT_APP_API: usar rutas relativas /v1/...
    }
    
    const getData = await axiosApiInstance.delete(apiUrl);
    return getData;
  } catch (err) {
    handledErrors(err);
  }
};

export const PostFileData = async (url, formData) => {
  try {
    // SIEMPRE respetar REACT_APP_API si está definida
    const backendUrl = process.env.REACT_APP_API || 'http://127.0.0.1:5001';
    
    const isLocal = !process.env.REACT_APP_API || 
                    process.env.REACT_APP_API.includes('localhost') || 
                    process.env.REACT_APP_API.includes('127.0.0.1');
    
    const isDevelopment = isLocal;
    
    // Asegurar que la URL empiece con /v1/
    let apiUrl = url.startsWith('/v1/') ? url : (url.startsWith('/') ? `/v1${url}` : `/v1/${url}`);
    
    // Si REACT_APP_API está definida, SIEMPRE usar URL completa
    if (process.env.REACT_APP_API) {
      apiUrl = apiUrl.replace(/^\/v1/, '');
      apiUrl = `${backendUrl}${apiUrl}`;
    } else if (isDevelopment) {
      apiUrl = apiUrl.replace(/^\/v1/, '');
      apiUrl = `${backendUrl}${apiUrl}`;
    } else {
      // Producción desplegada sin REACT_APP_API: usar rutas relativas /v1/...
    }
    
    const getData = await axiosApiInstance.post(
      apiUrl,
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      }
    );
    return getData;
  } catch (err) {
    handledErrors(err);
  }
};

const handledErrors = (fullError) => {
  if (!fullError.response) {
    // No hay respuesta del servidor (red, CORS, timeout, etc.)
    throw new Error("No se pudo conectar con el servidor. Verifica tu conexión.");
  }
  
  // Crear un objeto de error con más información
  const error = new Error();
  error.statusCode = fullError.response.status;
  error.response = fullError.response;
  
  switch (fullError.response.status) {
    case 401:
      localStorage.removeItem("authUser");
      window.location.href = "/login";
      error.message = "Unauthorized";
      throw error;
    case 404:
      error.message = "Endpoint no encontrado";
      throw error;
    case 400:
      // Para errores 400, extraer el mensaje del backend
      const errorData = fullError.response.data;
      if (errorData?.error?.message) {
        error.message = errorData.error.message;
      } else if (errorData?.message) {
        error.message = errorData.message;
      } else {
        error.message = "Solicitud inválida";
      }
      throw error;
    case 500:
      console.log(fullError.response);
      error.message = fullError.response.data?.message || "Error interno del servidor";
      throw error;
    default:
      error.message = fullError.response.data?.message || fullError.response.data?.error?.message || `Error ${fullError.response.status}`;
      throw error;
  }
};
